<div class="image-container">
  <div>
    <img
      [src]="imageUrl"
      [alt]="meal.recipe.title"
      deferLoad
      [fallback]="fallbackImageUrl"
    />
  </div>
  <ng-container  *ngIf="!isNarrowView">
    <ng-container *ngTemplateOutlet="removeButton"></ng-container>
  </ng-container>
</div>

<div class="meal-details">
  <p [ngClass]="{ 'sr-only': isNarrowView && !showDetails }" data-cy="mealTitle">{{ isNarrowView ? meal.recipe.title : truncateText(meal.recipe.title) }}</p>
  <div class="actions">
    <div class="serves">
      <cdx-svg-icon name="meal-serving" size="small" fill="light"></cdx-svg-icon>
      <span data-cy="servings">{{ meal.mealPlan?.addedServings }}</span>
    </div>
    <ng-container  *ngIf="isNarrowView">
      <ng-container *ngTemplateOutlet="removeButton"></ng-container>
    </ng-container>
  </div>
</div>

<ng-template #removeButton>
  <button
    type="button"
    (click)="removeMeal(meal)"
    [attr.aria-label]="'Remove ' + meal.recipe.title + ' from your meal plan'"
    title="Remove from your meal plan"
    class="removeButton"
    data-cy="removeMealButton"
  >
    <cdx-icon-circle name="cross" background="light" iconFill="green" size="extra-small" iconSize="tiny" borderColor="green"></cdx-icon-circle>
  </button>
</ng-template>